import { useState } from 'react';
import { Badge, OverlayTrigger } from 'react-bootstrap';
import Popover from 'react-bootstrap/Popover';
import { MdDelete } from 'react-icons/md';

type IProps = {
  confirm: () => void;
  title?: string;
  size?: number;
  children?: React.ReactNode;
};
const PopOver = ({ confirm, title, size, children }: IProps) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <OverlayTrigger
        rootClose
        trigger='click'
        placement='top'
        show={show}
        overlay={
          <Popover id={`popover-positioned`}>
            <Popover.Header as='h3'>
              {title || ' Are you sure to delete this ?'}
            </Popover.Header>
            <Popover.Body className='d-flex gap-2'>
              <Badge bg='primary' className='pointer' onClick={() => confirm()}>
                Yes
              </Badge>
              <Badge
                className='pointer'
                bg='danger'
                onClick={(e) => {
                  e.stopPropagation();
                  setShow(!show);
                }}
              >
                No
              </Badge>
            </Popover.Body>
          </Popover>
        }
      >
        <span
          className='pointer'
          onClick={() => {
            setShow(!show);
            // setData(sProduct);
          }}
        >
          {children || <MdDelete size={size || 20} color='red' />}
        </span>
      </OverlayTrigger>
    </>
  );
};

export default PopOver;
